<template>
  <div class="flex-auto flex flex-column items-center right" v-if="detail.cancelType == 0">
    <div class="flex text-center flex-item justify-between relative progress" style="margin: 0 auto">
      <template v-if="detail.refundStatus == 'FEFUND_SUCC'">
        <div class="absolute line-wrap"></div>
        <div class="flex relative items-center flex-column item">
          <img class="radius100 wh56" src="../../order/detail/images/finish.png" />
          <div class="f14">提交订单</div>
          <div class="f12 gray6">{{ detail.orderTime }}</div>
        </div>
        <div class="flex relative items-center flex-column item">
          <img class="radius100 wh56" src="../../order/detail/images/finish.png" />
          <div class="f14">付款成功</div>
          <div class="f12 gray6">{{ detail.paymentTime }}</div>
        </div>
        <div class="flex relative items-center flex-column item">
          <img class="radius100 wh56" src="../../order/detail/images/finish.png" />
          <div class="f14">退款成功</div>
        </div>
      </template>
      <template v-else>
        <div class="absolute line-wrap"></div>
        <div class="flex relative items-center flex-column item">
          <img class="radius100 wh56" src="../../order/detail/images/finish.png" />
          <div class="f14">提交订单</div>
          <div class="f12 gray6">{{ detail.orderTime }}</div>
        </div>
        <div class="flex relative items-center flex-column item">
          <img v-if="detail.orderStatus > 1" class="radius100 wh56" src="../../order/detail/images/finish.png" />
          <template v-else>
            <img class="radius100 wh56" src="../../order/detail/images/progress.png" />
            <div class="absolute white f18 num">2</div>
          </template>
          <div class="f14">付款成功</div>
          <div class="f12 gray6">{{ detail.paymentTime }}</div>
        </div>
        <div class="flex relative items-center flex-column item">
          <!--卖家发货-->
          <template v-if="detail.delivery != 2">
            <img v-if="detail.orderStatus > 2" class="radius100 wh56" src="../../order/detail/images/finish.png" />
            <template v-else>
              <img class="radius100 wh56" src="../../order/detail/images/progress.png" />
              <div class="absolute white f18 num">3</div>
            </template>
          </template>
          <!--买家自提-->
          <template v-if="detail.delivery == 2">
            <img
              v-if="detail.orderStatus > 2 && (detail.orderTransportDtlBo.pickupTime || detail.orderTransportDtlBo.sellerConfirmPickupTime)"
              class="radius100 wh56"
              src="../../order/detail/images/finish.png"
            />
            <template v-else>
              <img class="radius100 wh56" src="../../order/detail/images/progress.png" />
              <div class="absolute white f18 num">3</div>
            </template>
          </template>
          <div class="f14">{{ detail.delivery == "2" ? "买家自提" : "卖家发货" }}</div>
          <div class="f12 gray6" v-if="detail.delivery == 1">{{ detail.sendTime }}</div>
          <div class="f12 gray6" v-if="detail.delivery == 2">
            <div class="flex-auto mar10-b" v-if="!detail.orderTransportDtlBo.selfPickupTimeType">
              {{ detail.orderTransportDtlBo.pickupTime }}
            </div>
            <div class="flex-auto mar10-b" v-else-if="detail.orderTransportDtlBo.sellerConfirmPickupTime">
              {{ detail.orderTransportDtlBo.sellerConfirmPickupTimeStr }}
              {{ detail.orderTransportDtlBo.sellerConfirmPickupPeriod }}
            </div>
            <div class="flex-auto mar10-b" v-else>
              <div v-if="detail.orderTransportDtlBo.pressConfirmType == 0 || detail.orderTransportDtlBo.pressConfirmType == 1">
                <el-button type="primary" size="mini" @click="pressConfirmOrder(detail.orderId)">催确认</el-button>
              </div>
              <vid v-else>
                {{ "待卖家确认" }}
              </vid>
            </div>
          </div>
        </div>
        <div class="flex relative items-center flex-column item">
          <img v-if="detail.orderStatus > 3" class="radius100 wh56" src="../../order/detail/images/finish.png" />
          <template v-else>
            <img class="radius100 wh56" src="../../order/detail/images/progress.png" />
            <div class="absolute white f18 num">
              {{ detail.orderTransportDtlBo.sellerConfirmPickupPeriod }}
            </div>
          </template>
          <div class="f14">完成</div>
          <!-- <div v-if="detail.orderStatus > 3" class="f12 gray6 flex-auto mar10-b">{{ detail.receiveTime }}</div> -->
        </div>
      </template>
    </div>
    <div v-if="detail.deliveryModify && detail.deliveryModify.money" class="mar30-t">
      <div class="fb f15">
        订单涉及商品调整，产生退款<span class="red pad5-lr">￥{{ detail.deliveryModify.money }}</span
        >订单完成后，将退还至您的<span class="red pad5-lr">付款账户/预付款账户</span>，请注意查收
      </div>
      <div class="mar5-t pointer gray6" @click="$refs.deliveryModifyRef.open(detail.deliveryModify.refundGoodsList)">调整明细 ></div>
    </div>
    <DeliveryModify ref="deliveryModifyRef" />
    <div v-if="detail.orderTransportDtlBo && detail.orderTransportDtlBo.pickupTimeStartDate">
      提货期限：{{ detail.orderTransportDtlBo.pickupTimeStartDate }} - {{ detail.orderTransportDtlBo.pickupTimeEndDate }}
    </div>
  </div>
  <div class="flex text-center justify-center flex-auto right" v-else>
    <div class="flex flex-item justify-between relative progress" style="width: 340px">
      <div class="absolute line-wrap"></div>
      <div class="flex relative items-center flex-column item">
        <img class="radius100 wh56" src="../../order/detail/images/finish.png" />
        <div class="f14">提交订单</div>
        <div class="f12 gray6">{{ detail.orderTime }}</div>
      </div>
      <div class="flex relative items-center flex-column item">
        <img class="radius100 wh56" src="../../order/detail/images/finish.png" />
        <div class="f14">订单取消成功</div>
        <div class="f12 gray6">{{ detail.cancleTime }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../order/detail/detail.scss";
</style>

<script>
import DeliveryModify from "../orderDialog/deliveryModify/deliveryModify.vue";

export default {
  name: "order_info_dtl",
  components: {
    DeliveryModify,
  },
  props: {
    detail: {},
  },
  data() {
    return {
      env: process.env,
      loading: false,
    };
  },
  created() {},
  methods: {
    pressConfirmOrder(orderId) {
      console.log("orderId: ", orderId);
      this.$confirm("你确定要催确认吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = this.$loading({
          lock: false,
          text: "处理中...",
        });
        this.$store
          .dispatch("orderTo/index/pressSelfPickup", {
            orderId: orderId,
          })
          .then((res) => {
            this.loading.close();
            console.log(res);
            if (res.code === "0") {
              this.$alert("已催促卖家确认提货时间，请耐心等候如有问题请随时联系客服协助", "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },
  },
  // 监听器
  filters: {},
};
</script>
